/** Отдать пользователю файл, пришедший телом ответа.
 *
 *  ⚠️ Именно скачиванием, а не `window.open`. Вкладку, которую открывает не клик, а пришедший
 *  ответ сети, браузер режет блокировщиком всплывающих окон — и делает это МОЛЧА: ни файла, ни
 *  ошибки, кнопка выглядит сломанной. Скачивания блокировщик не касается.
 */
export function saveBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  // не отзываем синхронно: браузер к этому моменту не всегда успел прочитать ссылку
  setTimeout(() => URL.revokeObjectURL(url), 60_000);
}
